export const FETCH_APP_BUILDER_APP_INSTANCE = 'FETCH_APP_BUILDER_APP_INSTANCE'
export const FETCH_APP_BUILDER_APP_INSTANCE_SUCCESS = 'FETCH_APP_BUILDER_APP_INSTANCE_SUCCESS'
export const RESET_APP_BUILDER_APP_INSTANCE = 'RESET_APP_BUILDER_APP_INSTANCE'
export const CREATE_APP_BUILDER_FEATURE = 'CREATE_APP_BUILDER_FEATURE'
export const CREATE_APP_BUILDER_FEATURE_SUCCESS = 'CREATE_APP_BUILDER_FEATURE_SUCCESS'
export const UPDATE_APP_BUILDER_FEATURE_TRIGGER = 'UPDATE_APP_BUILDER_FEATURE_TRIGGER'
export const UPDATE_APP_BUILDER_FEATURE = 'UPDATE_APP_BUILDER_FEATURE'
export const UPDATE_APP_BUILDER_FEATURE_SUCCESS = 'UPDATE_APP_BUILDER_FEATURE_SUCCESS'
export const FETCH_APP_BUILDER_FEATURE = 'FETCH_APP_BUILDER_FEATURE'
export const FETCH_APP_BUILDER_FEATURE_NO_LOADER = 'FETCH_APP_BUILDER_FEATURE_NO_LOADER'
export const FETCH_APP_BUILDER_FEATURE_NO_LOADER_SUCCESS = 'FETCH_APP_BUILDER_FEATURE_NO_LOADER_SUCCESS'
export const FETCH_APP_BUILDER_FEATURE_SUCCESS = 'FETCH_APP_BUILDER_FEATURE_SUCCESS'
export const FETCH_APP_BUILDER_DATASOURCE_DOCS = 'FETCH_APP_BUILDER_DATASOURCE_DOCS'
export const FETCH_APP_BUILDER_DATASOURCE_DOCS_SUCCESS = 'FETCH_APP_BUILDER_DATASOURCE_DOCS_SUCCESS'
export const UPDATE_FEATURE_WORKFLOW = 'UPDATE_FEATURE_WORKFLOW'
export const UPDATE_FEATURE_STATUS = 'UPDATE_FEATURE_STATUS'
export const EXECUTE_APP_BUILDER_FEATURE = 'EXECUTE_APP_BUILDER_FEATURE'
export const EXECUTE_APP_BUILDER_FEATURE_SUCCESS = 'EXECUTE_APP_BUILDER_FEATURE_SUCCESS'
export const FETCH_APP_BUILDER_FEATURE_EXECUTION = 'FETCH_APP_BUILDER_FEATURE_EXECUTION'
export const FETCH_APP_BUILDER_FEATURE_EXECUTION_SUCCESS = 'FETCH_APP_BUILDER_FEATURE_EXECUTION_SUCCESS'
export const RESET_EXECUTE_APP_BUILDER_FEATURE = 'RESET_EXECUTE_APP_BUILDER_FEATURE'
export const FETCH_APP_BUILDER_NOTIFICATION_SOURCES = 'FETCH_APP_BUILDER_NOTIFICATION_SOURCES'
export const FETCH_APP_BUILDER_NOTIFICATION_SOURCES_SUCCESS = `FETCH_APP_BUILDER_NOTIFICATION_SOURCES_SUCCESS`
export const DEPLOY_APP_BUILDER_FEATURE = 'DEPLOY_APP_BUILDER_FEATURE'
export const DEPLOY_APP_BUILDER_FEATURE_SUCCESS = 'DEPLOY_APP_BUILDER_FEATURE_SUCCESS'
export const DEACTIVATE_APP_BUILDER_FEATURE = 'DEACTIVATE_APP_BUILDER_FEATURE'
export const PATCH_APP_BUILDER_FEATURE = 'PATCH_APP_BUILDER_FEATURE'
export const PATCH_APP_BUILDER_FEATURE_SUCCESS = 'PATCH_APP_BUILDER_FEATURE_SUCCESS'
export const CREATE_APP_BUILDER_APP_INSTANCE = 'CREATE_APP_BUILDER_APP_INSTANCE'
